export enum RouteNames {
  // System routes
  ROOT = "Root",
  NOT_FOUND = "NotFound",
  FORBIDDEN = "Forbidden",

  // Auth routes
  LOGIN = "Login",
  FORGET_PASSWORD = "ForgotPassword",
  RESET_PASSWORD = "ResetPassword",
  ACCEPT_INVITE = "AcceptInvite",

  // App routes
  DASHBOARD = "Dashboard",
  ORGANIZATION = "Organization",
  ORGANIZATIONS = "Organizations",
  CATALOG = "Catalog",
  BRANDS = "Brands",
  BRAND_DETAIL = "BrandDetail",
  ATTRIBUTES = "Attributes",
  PRODUCTS = "Products",
  PRODUCT_DETAIL = "ProductDetail",
  USERS = "Users",
  USER_DETAIL = "UserDetail",
  MY_PROFILE = "MyProfile",
  CHANNELS = "Channels",
  CHANNEL_CREATE = "ChannelCreate",
  CHANNEL_DETAIL = "ChannelDetail",
  MEDIA_ASSETS = "MediaAssets",
  COLLECTIONS = "Collections",
  COLLECTION_DETAIL = "CollectionDetail",
  IMPORTED_VIEW = "ImportedView",
  IMPORTS = "Imports",
  EXPORTS = "Exports",
}
